import { FieldGeneratorFieldType } from "../../FormFields/FieldGenerator/FieldGenerator"


export const propertyTypes = [
  { value: 'AGRITOURISM', text: 'Agritourism' },
  { value: 'APART_HOTEL', text: 'Apart Hotel' },
  { value: 'APARTMENT', text: 'Apartment' },
  { value: 'BED_AND_BREAKFAST', text: 'Bed & Breakfast' },
  { value: 'CABIN', text: 'Cabin' },
  { value: 'CAMPSITE', text: 'Campsite' },
  { value: 'CASTLE', text: 'Castle' },
  { value: 'CHALET', text: 'Chalet' },
  { value: 'CONDO', text: 'Condo' },
  { value: 'COTTAGE', text: 'Cottage' },
  { value: 'GUEST_HOUSE', text: 'Guest House' },
  { value: 'HOUSE_BOAT', text: 'House Boat' },
  { value: 'LODGE', text: 'Lodge' },
  { value: 'MOBILE_HOME', text: 'Mobile Home' },
  { value: 'PRIVATE_VACATION_HOME', text: 'Private Vacation Home' },
  { value: 'RESORT', text: 'Resort' },
  { value: 'RIAD', text: 'Riad' },
  { value: 'VILLA', text: 'Villa' },
]

export const aliasFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Alias',
    placeholder: 'Alias',
    fieldName: 'alias'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Alias Source',
    placeholder: 'Alias Source',
    fieldName: 'aliasSource'
  },
]

export const calendarFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Calendar Url',
    placeholder: 'Calendar Url',
    fieldName: 'url'
  },
  {
    fieldType: 'select',
    fieldLabel: 'Calendar Source',
    placeholder: '- Select Calendar Source -',
    fieldName: 'source',
    options: [
      { value: 'airbnb', text: 'AirBnB' },
      { value: 'homeaway', text: 'Homeaway' },
      { value: 'booking', text: 'Booking.com' },
      { value: 'rentalsUnited', text: 'Rentals United' },
      { value: 'internal', text: 'BenichayBrothers.com' },
    ]
  },
]

export const listedFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Listed Url',
    placeholder: 'Listed Url',
    fieldName: 'url'
  },
  {
    fieldType: 'select',
    fieldLabel: 'Listed Source',
    placeholder: '- Select Listed Source -',
    fieldName: 'source',
    options: [
      { value: 'airbnb', text: 'AirBnB' },
      { value: 'homeaway', text: 'Homeaway' },
      { value: 'booking', text: 'Booking.com' },
    ]
  },
  {
    fieldType: 'text',
    fieldLabel: 'Internal Name',
    placeholder: 'Internal Name',
    fieldName: 'internalName'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Internal Title',
    placeholder: 'Internal Title',
    fieldName: 'internalTitle'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Internal ID',
    placeholder: 'Internal ID',
    fieldName: 'internalId'
  }
]

export const aboutSectionsFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Section Title',
    placeholder: 'Section Title',
    fieldName: 'sectionTitle'
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Section Content',
    placeholder: 'Section Content',
    fieldName: 'content'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Section Image',
    placeholder: 'sectionImage',
    fieldName: 'sectionImage'
  },
  {
    fieldType: 'imageUpload',
    fieldLabel: 'Section Image',
    placeholder: 'sectionImage',
    fieldName: 'sectionImage'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Section Id',
    placeholder: 'sectionId',
    fieldName: 'sectionId'
  },
]

export const generateBlankAboutFieldEntry = () => ({ sectionId: '', sectionTitle: '', content: '' })

export const extraFeesFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Fee ID',
    placeholder: 'Fee ID',
    fieldName: 'feeId'
  },
  {
    fieldType: 'number',
    fieldLabel: 'Extra Fee Amount',
    placeholder: 'Extra Fee Amount',
    fieldName: 'amount'
  },
  {
    fieldType: 'select',
    fieldLabel: '- Select Fee Frequency -',
    placeholder: 'Fee Frequency',
    fieldName: 'frequency',
    options: [
      { value: 'once', text: 'Once' },
      { value: 'nightly', text: 'Nightly' },
    ]
  },
  {
    fieldType: 'text',
    fieldLabel: 'Fee Title',
    placeholder: 'Fee Title',
    fieldName: 'title'
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Fee Description',
    placeholder: 'Fee Description',
    fieldName: 'description'
  }
]


export const fontainePortalLinkedService = () => {
  return {
    linkedService: 'fontainePortal',
    linkedServiceId: JSON.stringify({
      "username": "USERNAME",
      "password": "PASSWORD",
      "email": "EMAIL",
      "phone": "PHONE"
    })
  }
}

export const fontainePropertyLinkedService = () => {
  return {
    linkedService: 'fontaine',
    linkedServiceId: JSON.stringify({})
  }
}

// export const fontaineHotelProgramLinkedService = () => {
//   return {
//     linkedService: 'fontaineHotelProgram',
//     linkedServiceId: JSON.stringify({})
//   }
// }

export const blockingLinkedService = () => {
  return {
    linkedService: 'blockingProperty',
    linkedServiceId: JSON.stringify({})
  }
}

export const earlyCheckInLinkedService = () => {
  return {
    linkedService: 'earlyCheckIn',
    linkedServiceId: JSON.stringify({
      enabled: true,
      options: [
        {
          title: 'Free 3pm Check In',
          price: 0,
          hours: 1
        },
        {
          title: '$65 12pm Check In',
          price: 65,
          hours: 4
        }
      ]
    })
  }
}

export const lateCheckOutLinkedService = () => {
  return {
    linkedService: 'lateCheckOut',
    linkedServiceId: JSON.stringify({
      enabled: true,
      options: [
        {
          title: 'Free 12pm Check Out',
          price: 0,
          hours: 1
        },
        {
          title: '$65 2pm Check Out',
          price: 65,
          hours: 3
        }
      ]
    })
  }
}

export const remoteLockLinkedService = () => {
  return {
    linkedService: 'remoteLock',
    linkedServiceId: JSON.stringify({
      deviceId: 'DEVICE_ID',
      deviceName: 'DEVICE_NAME',
      deviceType: 'locks'
    })
  }
}

export const parkingLinkedService = () => {
  return {
    linkedService: 'parking',
    linkedServiceId: JSON.stringify({
      parkingType: 'PARKING_TYPE',
      parkingGroups: ['PARKING_LOCATION'],
      parkingCost: 35,
    })
  }
}

export const gateCodeLinkedService = () => {
  return {
    linkedService: 'gateCode',
    linkedServiceId: JSON.stringify({
      codes: [
        {
          for: 'CODE_FOR',
          code: 'CODE_NUMBER'
        }
      ]
    })
  }
}

export const hotelCleaningFee = () => {
  return {
    feeId: 'hotelCleaning',
    amount: 205,
    frequency: 'once',
    title: 'Hotel Cleaning',
    description: 'Cleaning fee for hotel stay + tax'
  }
}

export const hotelDepositFee = () => {
  return {
    feeId: 'hotelDeposit',
    amount: 250,
    frequency: 'nightly',
    title: 'Hotel Deposit',
    description: 'Deposit fee per night'
  }
}

export const hotelResortFee = () => {
  return {
    feeId: 'hotelResort',
    amount: 16.52,
    frequency: 'once',
    title: 'Hotel Resort',
    description: 'Resort fee for hotel stay'
  }
}

export const hotelCheckInFee = () => {
  return {
    feeId: 'hotelCheckIn',
    amount: 75,
    frequency: 'once',
    title: 'Hotel Check-In',
    description: 'Check-in fee for hotel stay'
  }
}

export const hourSelection = [
  { value: 0, text: '0' },
  { value: 1, text: '1' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5' },
  { value: 6, text: '6' },
  { value: 7, text: '7' },
  { value: 8, text: '8' },
  { value: 9, text: '9' },
  { value: 10, text: '10' },
  { value: 11, text: '11' },
  { value: 12, text: '12' },
  { value: 13, text: '13' },
  { value: 14, text: '14' },
  { value: 15, text: '15' },
  { value: 16, text: '16' },
  { value: 17, text: '17' },
  { value: 18, text: '18' },
  { value: 19, text: '19' },
  { value: 20, text: '20' },
  { value: 21, text: '21' },
  { value: 22, text: '22' },
  { value: 23, text: '23' },
]

export const minuteSelection = [
  { value: 0, text: '00' },
  { value: 15, text: '15' },
  { value: 30, text: '30' },
  { value: 45, text: '45' },
]

export const areaUnits = [
  { value: 'sqft', text: 'Square Feet' },
  { value: 'sqm', text: 'Square Meters' },
]

export const regulatoryCategories = [
  { value: 'HOTEL', text: 'Hotel' },
  { value: 'LONG_TERM_ONLY', text: 'Long Term Only' },
  { value: 'VACATION_RENTAL', text: 'Vacation Rental' },
]

export const regulatoryTypes = [
  { value: 'residence', text: 'Residence' },
  { value: 'hotel', text: 'Hotel' },
]

export const recordTypes = [
  { value: 'REGISTRATION_NUMBER', text: 'Registration Number' },
  { value: 'BUSINESS_TAX_RECEIPT_NUMBER', text: 'Business Tax Receipt Number' },
  { value: 'RESORT_TAX_ID', text: 'Resort Tax ID' },
  { value: 'CERTIFICATE_OF_USE_NUMBER', text: 'Certificate of Use Number' },
  { value: 'HOTEL_LICENSE', text: 'Hotel License' },
]

// Spaces constants

export const bathroomTypes = [
  { value: 'FULL_BATH', text: 'Full Bath' },
  { value: 'NO_TUB_OR_SHOWER', text: 'Half Bath (No Tub or Shower)' },
  { value: 'SHOWER_INDOOR_OR_OUTDOOR', text: 'Shower (Indoor or Outdoor)' },
]

export const bathroomAmenitySlugs = [
  { value: 'bidet', text: 'Bidet' },
  { value: 'bathtub', text: 'Bathtub' },
  { value: 'outdoor-shower', text: 'Outdoor Shower' },
  { value: 'toilet', text: 'Toilet' },
  { value: 'bathtub-shower', text: 'Bathtub/Shower' },
]

export const bathroomAmenitySubTypes = [
  { value: 'BATHTUB_OR_SHOWER', text: 'Bathtub or Shower' },
  { value: 'SHOWER_ONLY', text: 'Shower Only' },
  { value: 'BATHTUB', text: 'Bathtub' },
  { value: 'JETTED_BATHTUB', text: 'Jetted Bathtub' },
]

export const spaceBathroomAmenityFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'select',
    fieldLabel: 'Slug',
    placeholder: '- Select Slug -',
    fieldName: 'slug',
    options: bathroomAmenitySlugs,
    layout: { xs: 12, md: 6 },
  },
  {
    fieldType: 'select',
    fieldLabel: 'Sub Type',
    placeholder: '- Select Sub Type -',
    fieldName: 'subType',
    options: bathroomAmenitySubTypes,
    layout: { xs: 12, md: 6 },
    condition: (values: any) => values.slug && (values.slug !== 'bidet' && values.slug !== 'toilet'),
  },
]

export const spaceBathroomFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Title',
    placeholder: 'Title',
    fieldName: 'title',
    layout: { xs: 12, md: 8 },
  },
  {
    fieldType: 'select',
    fieldLabel: 'Bathroom Type',
    placeholder: '- Select Bathroom Type -',
    fieldName: 'bathroomType',
    options: bathroomTypes,
    layout: { xs: 12, md: 4 },
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Description',
    placeholder: 'Description',
    fieldName: 'description',
  },
  {
    fieldType: 'array',
    fieldLabel: 'Amenities',
    fieldName: 'amenities',
    extra: {
      fields: spaceBathroomAmenityFieldValues,
      blankEntryFn: () => ({ slug: '', subType: '' }),
    },
  },
]

export const bedSizes = [
  { value: 'TWIN', text: 'Twin' },
  { value: 'FULL', text: 'Full' },
  { value: 'QUEEN', text: 'Queen' },
  { value: 'KING', text: 'King' },
  { value: 'CHILD', text: 'Child' },
  { value: 'CRIB', text: 'Crib' },
]

export const bedTypes = [
  { value: 'BUNK_BED', text: 'Bunk Bed' },
  { value: 'TWIN_BED', text: 'Twin Bed' },
  { value: 'FUTON', text: 'Futon' },
  { value: 'FULL_BED', text: 'Full Bed' },
  { value: 'MURPHY_BED', text: 'Murphy Bed' },
  { value: 'SOFA_BED', text: 'Sofa Bed' },
  { value: 'QUEEN_BED', text: 'Queen Bed' },
  { value: 'KING_BED', text: 'King Bed' },
  { value: 'CRIB_FIXED', text: 'Crib (Fixed)' },
  { value: 'CHILD_BED', text: 'Child Bed' },
]

export const spaceBedFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'select',
    fieldLabel: 'Size',
    placeholder: '- Select Size -',
    fieldName: 'size',
    options: bedSizes,
    layout: { xs: 12, md: 4 },
  },
  {
    fieldType: 'select',
    fieldLabel: 'Bed Type',
    placeholder: '- Select Bed Type -',
    fieldName: 'bedType',
    options: bedTypes,
    layout: { xs: 12, md: 5 },
  },
  {
    fieldType: 'number',
    fieldLabel: 'Quantity',
    placeholder: 'Quantity',
    fieldName: 'quantity',
    layout: { xs: 12, md: 3 },
  },
]

export const spaceBedroomFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Title',
    placeholder: 'Title',
    fieldName: 'title',
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Description',
    placeholder: 'Description',
    fieldName: 'description',
  },
  {
    fieldType: 'array',
    fieldLabel: 'Beds',
    fieldName: 'beds',
    extra: {
      fields: spaceBedFieldValues,
      blankEntryFn: () => ({ size: '', bedType: '', quantity: 1 }),
    },
  },
]

export const spaceDiningRoomFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Title',
    placeholder: 'Title',
    fieldName: 'title',
    layout: { xs: 12, md: 5 },
  },
  {
    fieldType: 'number',
    fieldLabel: 'Capacity',
    placeholder: 'Capacity',
    fieldName: 'capacity',
    layout: { xs: 12, md: 2 },
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Description',
    placeholder: 'Description',
    fieldName: 'description',
  },
]
